import styles from './person-activity.module.scss';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import PersonActivityGrid from '../person-activity-grid/person-activity-grid';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface PersonActivityProps { }

export function PersonActivity(props: PersonActivityProps) {
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.personActivity")} />
            <PersonActivityGrid />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default PersonActivity;